// extracted by mini-css-extract-plugin
export default {"my_btn":"MyBtn_my_btn__5EFjx"};